import calls from '@/backend/api-calls'

const state = () => ({
  documents: [],
  documentTypes: [],
  documentTypesLoading: false,
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    document_type_id: null
  }
})

// getters
const getters = {
  ids: state => {
    return state.documents.map(d => d.id);
  }
}

// actions
const actions = {
  getDocuments: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.documents.get(parameters)
        .then(resp => {
          commit("setDocuments", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addDocument: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.documents.post(data)
        .then(resp => {
          commit("insertDocument", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateDocument: ({commit}, { documentId, data }) => {
    return new Promise((resolve, reject) => {
      calls.document.put(documentId, data)
        .then(resp => {
          commit("insertUpdatedDocument", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addAttachment: ({commit}, { documentId, data }) => {
    return new Promise((resolve, reject) => {
      calls.document.addAttachment(documentId, data)
        .then(resp => {
          commit("insertAttachment", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteDocument: ({commit}, documentId) => {
    return new Promise((resolve, reject) => {
      calls.document.delete(documentId).then(
        resp => {
          commit("removeDocument", documentId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Document successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  },
  getDocumentTypes: ({commit}, parameters) => {
    commit("setDocumentTypesLoading", true);
    return new Promise((resolve, reject) => {
      calls.documentTypes.get(parameters)
        .then(resp => {
          commit("setDocumentTypes", resp.data.results);
          commit("setDocumentTypesLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addDocumentType: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.documentTypes.post(data)
        .then(resp => {
          commit("insertDocumentType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateDocumentType: ({commit}, { documentTypeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.documentType.put(documentTypeId, data)
        .then(resp => {
          commit("insertUpdatedDocumentType", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteDocumentType: ({commit}, documentTypeId) => {
    return new Promise((resolve, reject) => {
      calls.documentType.delete(documentTypeId).then(
        resp => {
          commit("removeDocumentType", documentTypeId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Document type successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  }
}

// mutations
const mutations = {
  setLoading (state, data) {
    state.loading = data;
  },
  setDocuments (state, data) {
    state.documents = data.results;
    state.pagination = data.pagination;
  },
  insertDocument (state, data) {
    state.documents.push(data);
  },
  insertUpdatedDocument (state, data) {
    state.documents.forEach((document, i) => {
      if (document.id == data.id) {
        state.documents.splice(i, 1, data);
      }
    })
  },
  insertAttachment (state, data) {
    state.documents.forEach(document => {
      if (document.id == data.id) {
        document.attachment = data.attachment;
      }
    })
  },
  removeDocument (state, documentId) {
    state.documents.forEach((document, i) => {
      if (document.id == documentId) {
        state.documents.splice(i, 1);
        const index = state.selected.indexOf(documentId);
        if (index != -1) {
          state.selected.splice(index, 1);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  // document types
  setDocumentTypesLoading (state, data) {
    state.documentTypesLoading = data;
  },
  setDocumentTypes (state, data) {
    state.documentTypes = data;
  },
  insertDocumentType (state, data) {
    state.documentTypes.push(data);
  },
  insertUpdatedDocumentType (state, data) {
    state.documentTypes.forEach((documentType, i) => {
      if (documentType.id == data.id) {
        state.documentTypes.splice(i, 1, data);
      }
    })
  },
  removeDocumentType (state, documentTypeId) {
    state.documentTypes.forEach((documentType, i) => {
      if (documentType.id == documentTypeId) {
        state.documentTypes.splice(i, 1);
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}